import React, { useEffect, useState } from 'react';
import Grid from '@material-ui/core/Grid';
import BillingInfoProvider from '../../../components/BillingInfoProvider';
import CompanyInformation from './CompanyInformation';
import InvoicingAddress from './InvoicingAddress';
import PaymentMethods from './PaymentMethods';
import InvoicesOverview from './InvoicesOverview';
import UpcomingInvoices from './UpcomingInvoices';
import { subscription as subscriptionApi } from '@afosto/iam/api/Subscription';

const BillingInformation = () => {
  const [billingAddress, setBillingAddress] = useState({});
  const [companyInformation, setCompanyInformation] = useState({});
  const [isFetchingBillingInfo, setIsFetchingBillingInfo] = useState(true);

  useEffect(() => {
    let isMounted = true;

    const fetchBillingInformation = async () => {
      setIsFetchingBillingInfo(true);

      try {
        const response = await subscriptionApi.getBillingInformation();
        const { data = {} } = response;
        const { address = {}, ...rest } = data;

        if (isMounted) {
          setBillingAddress(address);
          setCompanyInformation(rest);
        }
      } catch (err) {
        if (isMounted) {
          setBillingAddress({});
          setCompanyInformation({});
        }
      } finally {
        if (isMounted) {
          setIsFetchingBillingInfo(false);
        }
      }
    };

    fetchBillingInformation();

    return () => {
      isMounted = false;
    };
  }, []);

  return (
    <BillingInfoProvider
      value={{
        billingAddress,
        companyInformation,
        isFetchingBillingInfo,
        setBillingAddress,
        setCompanyInformation,
      }}
    >
      <Grid container spacing={1}>
        <Grid item xs={12} md={6}>
          <CompanyInformation />
        </Grid>
        <Grid item xs={12} md={6}>
          <InvoicingAddress />
        </Grid>
        <Grid item xs={12}>
          <PaymentMethods />
        </Grid>
        <Grid item xs={12}>
          <UpcomingInvoices />
        </Grid>
        <Grid item xs={12}>
          <InvoicesOverview />
        </Grid>
      </Grid>
    </BillingInfoProvider>
  );
};

export default BillingInformation;
